module.exports = __webpack_public_path__ + "spine/building_celebration_9x9.json?3bc54ed804d4f850987d314c59a5914f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/building_construction/building_celebration_9x9.json
// module id = 1756
// module chunks = 3